import { useCallback, useEffect, useState } from 'react';

import { ComboboxMulti } from 'twyne-new.ui';

import { useGrid } from '@Components/Grid';

export default function SelectPermissions() {
  const { state: { setFilters, filters } } = useGrid()

  const [permissions, setPermissions] = useState([{ label: "all", value: undefined }])

  useEffect(() => {
    if (!filters) {
      setPermissions([{ label: "all", value: undefined }])
    }
  }, [filters])

  const handleChangeFilters = useCallback(options => {
    setFilters(filters => {
      PERMISSIONS_OPTIONS.forEach(option => delete filters[option.value])
      options.length && options.map(value => filters[value] = true)
      return { ...filters }
    })
  }, [setFilters])

  const handleChange = useCallback(options => {
    options = options.filter(({ value }) => value !== undefined)
    options.length ? setPermissions(options) : setPermissions([{ label: "all", value: undefined }])
    handleChangeFilters(options.map(({ value }) => value))
  }, [handleChangeFilters])

  return <ComboboxMulti
    id="permissions"
    options={PERMISSIONS_OPTIONS}
    value={permissions}
    onChange={handleChange}
  />
}

const PERMISSIONS_OPTIONS = [
  { label: 'Path', value: 'path' },
  { label: 'Reports', value: 'report' },
  { label: 'CMS', value: 'cms' },
  { label: 'Offer', value: 'offer' },
  { label: 'Form', value: 'form' },
  { label: 'Settings', value: 'setting' },
]
